import React from 'react';
import { Shield } from 'react-feather';
import useTranslation from 'next-translate/useTranslation';
import { TextBolder14 } from '../../VuexyDesign/atoms/Text';
import { TextRegular14 } from '../common/Text';

const YourMusicIsSafe = () => {
  const { t } = useTranslation('upload');
  return (
    <div
      className="bg-light rounded d-flex py-2 px-2 my-2"
      style={{ border: 'solid 2px #B9B9C3' }}
    >
      <div
        className="bg-white rounded d-flex justify-content-center align-items-center mr-1"
        style={{ height: '25px', width: '30px' }}
      >
        <Shield size={18} color="black" />
      </div>
      <div className="d-flex flex-column">
        <TextBolder14>{t('upload:yourMusicIsSafe') as string}</TextBolder14>
        <TextRegular14>{t('upload:securityStatement') as string}</TextRegular14>
      </div>
    </div>
  );
};

export default YourMusicIsSafe;
